<template>
  <div class="wrapper">
    <div class="page-header">
      <div>
        <img src="../image/logo/sys-logo.png" />
        <p>芭田追溯管理平台</p>
        <!-- <span @click="goIndex">返回首页</span> -->
      </div>
    </div>
    <div class="body-box">
      <div class="left">
        <img src="../image/logo/admin_banner.png" />
      </div>
      <div class="right-nav">
        <div class="right">
          <div class="user-log">用户登录</div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            @keyup.enter.native="submitForm('ruleForm')"
          >
            <el-form-item prop="username">
              <el-input v-model="ruleForm.username" placeholder="用户名/手机号">
                <template slot="prepend"
                  ><img
                    src="../image/website/icon-user.png"
                    class="icon-user"
                /></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                type="password"
                v-model="ruleForm.password"
                placeholder="请输入密码"
              >
                <template slot="prepend"
                  ><img
                    src="../image/website/icon-pwd.png"
                    class="icon-user"
                /></template>
              </el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                v-model="ruleForm.code"
                placeholder="验证码"
                class="input3"
              >
                <template slot="prepend"
                  ><img
                    src="../image/website/icon-yan.png"
                    class="icon-user"
                /></template> </el-input
              ><img
                :src="verificationImg"
                @click="checkImageCode"
                class="image"
              />
            </el-form-item>
            <el-button
              type="primary"
              :loading="isLoad"
              @click="submitForm('ruleForm')"
              >立即登录</el-button
            >
          </el-form>
          <div class="login-blocks">
            <span @click="btn1">忘记密码</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  queryUserFlag,
  validateImgCode,
  login,
  queryCompanyUserMenus,
} from "@/common/api.js";
import webSiteFooter from "@/components/webSiteFooter";
export default {
  components: {
    webSiteFooter,
  },
  props: {},
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        code: "",
      },
      isLoad: false,
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        code: [
          { required: true, validator: this.validateCode, trigger: "blur" },
        ],
      },
      userFlag: "", //随机标识
      verificationImg: "",
    };
  },
  watch: {},
  computed: {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoad = true;
          var params = {
            userName: this.ruleForm.username,
            password: this.ruleForm.password,
          };
          console.log(params);
          login(params).then((res) => {
            this.isLoad = false;
            if (res.errorCode == 200) {
              if (
                res.companyUserVO.companyInfo &&
                res.companyUserVO.companyInfo.authFlag == 1
              ) {
                this.$message.error("审核中，请稍后重试！");
                return;
              } else if (
                res.companyUserVO.companyInfo &&
                res.companyUserVO.companyInfo.authFlag == 3
              ) {
                this.$message.error("审核没有通过，请联系客服！");
                return;
              }
              var token = res.token;
              var userType = res.userType;
              var userName = res.companyUserVO.userName;
              var userId = res.companyUserVO.userId;
              var isMain = res.companyUserVO.isMain;
              var telphone = res.companyUserVO.contactPhone;
              var contactPerson = res.companyUserVO.contactPerson;
              var companyType = res.companyUserVO.companyInfo.companyType;
              var companyId = res.companyUserVO.companyId;
              var companyName = res.companyUserVO.companyInfo.companyName;
              this.queryCompanyUserMenus();
              this.$store.dispatch("getCompanyType", companyType);
              window.sessionStorage.setItem("companyId", companyId);
              window.sessionStorage.setItem("token", token);
              window.sessionStorage.setItem("userType", userType);
              window.sessionStorage.setItem("userName", userName);
              window.sessionStorage.setItem("userId", userId);
              window.sessionStorage.setItem("companyName", companyName);
              window.sessionStorage.setItem("isMain", isMain);
              window.sessionStorage.setItem("telphone", telphone);
              window.sessionStorage.setItem("contactPerson", contactPerson);
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 获取导航菜单
    queryCompanyUserMenus() {
      queryCompanyUserMenus().then((res) => {
        console.log("res :>> ", res);
        if (res.errorCode == 200) {
          if (res.companyNavigationPer) {
            window.sessionStorage.setItem(
              "routerList",
              JSON.stringify(res.companyNavigationPer.children)
            );
            this.level1Menu = res.systemNavigations;
            this.$store.dispatch("getlevel1Menu", this.level1Menu);
          }
          this.$nextTick(function () {
            this.$router.push({
              path: "/user/home",
            });
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getImageCode(userFlag) {
      this.$axios({
        method: "post",
        url: "/permissions/regist/createValidateImg",
        data: {
          userFlag: userFlag,
        },
        responseType: "arraybuffer",
        ContentType: "application/json;charset=UTF-8",
      }).then((response) => {
        console.log("res :>> ", response);
        if (response.data) {
          this.verificationImg =
            "data:image/png;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            );
        }
      });
    },
    checkImageCode() {
      this.getqueryUserFlag();
    },
    getqueryUserFlag() {
      queryUserFlag().then((res) => {
        if (res.errorCode == 200) {
          this.userFlag = res.userFlag;
          this.getImageCode(this.userFlag);
        }
      });
    },
    validateCode(rule, value, callback) {
      var params = {
        userFlag: this.userFlag,
        imageCheckCode: value,
      };
      if (value == "") {
        callback(new Error("请输入图文验证码"));
      }
      if (value) {
        validateImgCode(params).then((res) => {
          if (res.errorCode != 200) {
            callback(new Error(res.msg));
          }
          callback();
        });
      }
    },
    btn1() {
      this.$router.push({
        path: "/forgetPassword",
      });
    },
  },
  created() {},
  mounted() {
    this.getqueryUserFlag();
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  position: absolute;
  width: 100%;
  height: 100%;
  background: -webkit-linear-gradient(#cae9fd, #ffffff);
  background: -o-linear-gradient(#cae9fd, #ffffff);
  background: -moz-linear-gradient(#cae9fd, #ffffff);
  background: linear-gradient(#cae9fd, #ffffff);
  .page-header {
    height: 90px;
    background-color: #ffffff;
    div {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      line-height: 90px;
      img {
        vertical-align: top;
        height: 60px;
        margin-top: 15px;
      }
      p {
        height: 90px;
        line-height: 90px;
        font-size: 40px;
        flex-grow: 1;
        text-align: center;
      }
      span {
        font-size: 16px;
        color: #1492ff;
        cursor: pointer;
      }
    }
  }
  .body-box {
    width: 1100px;
    height: 450px;
    margin: 120px auto;
    position: relative;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
    .left {
      position: absolute;
      left: 0;
      top: 0;
      width: 610px;
      height: 450px;
      background-color: #409eff;
      text-align: right;
      img {
        width: 610px;
        height: 100%;
      }
    }
    .right-nav {
      position: absolute;
      top: 0;
      right: 0;
      width: 350px;
      height: 350px;
      padding: 50px 70px;
      background-color: #fff;
      .user-log {
        text-align: center;
        font-size: 26px;
        font-weight: bold;
        color: #1492ff;
        margin-bottom: 20px;
      }
    }
  }
  .login-blocks {
    margin-top: 20px;
    text-align: right;
    span {
      margin-left: 15px;
      font-size: 13px;
      color: #2e63f7;
      cursor: pointer;
    }
  }
  .icon-user {
    height: 24px;
    width: 24px;
  }
  /deep/.el-input-group__prepend {
    padding: 0 10px;
    background-color: #ccc;
  }
  .el-form {
    .input3 {
      width: 80%;
    }
    .image {
      width: 20%;
      vertical-align: bottom;
      height: 40px;
      cursor: pointer;
    }
    .el-button {
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/Login.vue